import React from 'react'
import { Col, Row } from 'antd'
import { connect } from 'react-redux'
import Layout from '../../components/Layout'
import actions from '../../redux/actions'
import Divider from '../../components/Divider'
import styled from 'styled-components'

const Text = styled.p`
  font-size: 18px;
  line-height: 24.3px;
`

const StyledCol = styled(Col)`
  margin: 1rem 0 !important;
`

const Children = (props) => {
  const handleClick = (id,value) => {
    props.setChildren(id,value)
    props.history.goBack()
  }

  const value = [
    {id: '0', text: 'ไม่มี'},
    {id: '1', text: '1'},
    {id: '2', text: '2'},
  ]

  return (
    <Layout title={'จำนวนบุตร หรือบุตรบุญธรรม'} backIcon={true} onClick={() => props.history.goBack()}>
      <h4 style={{marginTop: '2rem', marginBottom: '1rem'}}>กรุณาเลือกจำนวนบุตร หรือบุตรบุญธรรม</h4>
      <Row>
        {
          value.map(element =>
            <StyledCol key={element.id}>
              <Text onClick={() => handleClick(element.id,element.text)}>{element.text}</Text>
              <Divider floatRight={true}/>
            </StyledCol>
          )
        }
      </Row>
    </Layout>
  )
}

const mapDispatchToProps = {
  setChildren: actions.setChildren,
}

const ChildrenWithConnect = connect(null, mapDispatchToProps)(Children)

export default ChildrenWithConnect
